import React from 'react'

export default class Figure extends React.Component {
    render() {        
        return (
            <div className="figure-wrapper">
                <div className="figure">
                <div className={`figure-img ${ this.props.styleName }`}></div>
                    <p className="figure-desc">{this.props.desc}</p>
                </div>
                
            </div>
        );
        
    }
    
  }

// získat prop.type tohoto elementu
// poslat ho filtru


// WEBPACK FOOTER //
// ./src/components/Figure.js